import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ImportSummary {
  [tableName: string]: number;
}

@Injectable({ providedIn: 'root' })
export class DataTransferService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/api/data`;

  readonly exporting = signal(false);
  readonly importing = signal(false);

  async exportToXlsx(): Promise<void> {
    this.exporting.set(true);
    try {
      const blob = await lastValueFrom(
        this.http.get(`${this.apiUrl}/export`, { responseType: 'blob' })
      );
      this.downloadBlob(blob, 'ecodados_database_export.xlsx');
    } finally {
      this.exporting.set(false);
    }
  }

  async importFromXlsx(file: File, mode: 'AUTO' | 'LEGACY' | 'EXPORT' = 'AUTO', cleanImport: boolean = false): Promise<ImportSummary> {
    this.importing.set(true);
    try {
      const formData = new FormData();
      formData.append('file', file);

      return await lastValueFrom(
        this.http.post<ImportSummary>(`${this.apiUrl}/import?mode=${mode}&cleanImport=${cleanImport}`, formData)
      );
    } finally {
      this.importing.set(false);
    }
  }

  private downloadBlob(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
}
